import { render } from "./Trainingszeiten.vue?vue&type=template&id=681f10ce"
import script from "./Trainingszeiten.vue?vue&type=script&lang=js"
export * from "./Trainingszeiten.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__